import { useTranslation } from 'react-i18next';
import { SubtitleWrapper } from './HostfullyAssistSubtitle.styles';

const HostfullyAssistSubtitle = () => {
  const { t } = useTranslation();

  return (
    <SubtitleWrapper data-testid="hostfully-assist-subtitle">
      <p>{t('pageIntegrations.integrationDetails.hostfullyAssistSubtitle')}</p>
    </SubtitleWrapper>
  );
};

export default HostfullyAssistSubtitle;
